module.exports = __webpack_public_path__ + "img/1210935826.ad2b0170.jpg";